import { action, observable } from 'mobx';
import Alert from 'react-s-alert';

import { AppManager, Input } from 'core/index';

import { FormStore } from 'libs/forms/app';

import { clientStore } from 'apps/client/app';
import { InviteModel, InvitesArrayApp } from 'apps/group/app';
import {
  SignUpInvitesQuery,
  InviteUserToSignUpMutation,
  RequestInvitesMutation,
} from 'apps/group/gql';

import { conf } from 'apps/profile/invitations/config.yaml';

export class InvitationsAppManager extends AppManager {
  static registryName = 'InvitationsAppManager';
  @observable invite = '';
  @observable msg = '';
  constructor(parent, init = {}) {
    super(parent, init);
    this.AppRef('sentInvites', InvitesArrayApp);
    this.newInvitesInput = new Input({
      emails: () => this.invite,
    });
    this.requestInvitesInput = new Input({
      msg: () => this.msg,
    });
    this.sendInvites = new FormStore(this, conf, 'sendInvites');
    this.requestInvites = new FormStore(this, conf, 'requestInvites');
    this.NewInvitesQuery();
  }

  @action NewInvitesQuery = () => {
    const q = new SignUpInvitesQuery(this, {
      queryKey: 'sentInvites',
      onSysErr: this.onInvitesError,
    });
    q.process(invites => {
      if (invites !== null) {
        if (invites.length > 0 && invites[0].invitesLeft) {
          clientStore.signedInProfile.upstream.invitesLeft =
            invites[0].invitesLeft;
          clientStore.SetSignedInProfile(clientStore.signedInProfile.upstream);
        }
        return invites.map(invite => InviteModel.Load(invite));
      }
      return [];
    }, this.InvitesUpdate);
    q.query();
  };

  @action InvitesUpdate = inviteModels => {
    this.sentInvites = inviteModels;
    this.sentInvites.ResetLocals();
  };

  @action SendInvites = () => {
    if (this.sendInvites.isValid) {
      this.sendInvites.SetPosting(true);
      clientStore.SetPosting(true);
      this.mutations.push(
        InviteUserToSignUpMutation.New(this.newInvitesInput, {
          onSysErr: this.onError,
          onUserErr: this.onError,
          onSuccess: this.onInviteSuccess,
        }),
      );
    } else {
      this.sendInvites.alert();
    }
  };

  @action onInviteSuccess = result => {
    this.sendInvites.SetPosting(false);
    this.sendInvites.clearDraft();
    clientStore.SetPosting(false);
    Alert.success('Invite sent.');
    this.invite = '';
    this.NewInvitesQuery();
    clientStore.signedInProfile.upstream.invitesLeft =
      result.inviteUsersToSignup.invitesLeft;
    clientStore.SetSignedInProfile(clientStore.signedInProfile.upstream);
  };

  @action RequestInvites = () => {
    if (this.requestInvites.isValid) {
      this.sendInvites.SetPosting(true);
      clientStore.SetPosting(true);
      this.mutations.push(
        RequestInvitesMutation.New(this.requestInvitesInput, {
          onSysErr: this.onError,
          onUserErr: this.onError,
          onSuccess: this.onApplySuccess,
        }),
      );
    } else {
      this.requestInvites.alert();
    }
  };

  @action onApplySuccess = () => {
    this.sendInvites.SetPosting(false);
    this.sendInvites.clearDraft();
    clientStore.SetPosting(false);
    Alert.success("Received. We'll get back to you asap.");
    this.msg = '';
    this.NewInvitesQuery();
  };

  @action onError = () => {
    Alert.error('Hmm... Something went wrong, please try again.');
    this.sendInvites.SetPosting(false);
    clientStore.SetPosting(false);
  };
}
